module.exports = __webpack_public_path__ + "img/Unidad18-1.9791ca5d.png";